import useRequiredId from './useRequiredId';

export default useRequiredId;
